import { CornerMarks, GaugeBar, RackDiagram } from "@/components/infra";

const RACK_METRICS = [
  { id: "compute", label: "Compute", value: "18U / 24U", percentage: 75 },
  { id: "power", label: "PDU draw", value: "11.2 kW", percentage: 75 },
  { id: "temperature", label: "Inlet temp", value: "23.4°C", percentage: 58 },
];

export const HeroRackPanel = () => (
  <section data-testid="hero-rack-demo-card" aria-labelledby="hero-rack-title" className="chrome-surface relative min-w-0 flex flex-col">
    <CornerMarks color="#A9ADB4" />
    <div className="min-h-14 px-4 sm:px-5 py-3 border-b hairline flex flex-wrap items-center justify-between gap-3">
      <h2 id="hero-rack-title" data-testid="hero-rack-title" className="font-mono-label text-[11px] !tracking-normal text-[#3D4049]">Rack · DCYB-A12 · 24U</h2>
      <span data-testid="hero-rack-demo-label" className="inline-flex items-center gap-1.5 font-mono-label text-[9px] !tracking-normal text-[#5F6168]"><span className="w-1 h-1 rounded-full bg-[#71747B]" aria-hidden="true" />EDUCATIONAL DEMO</span>
    </div>
    <div className="flex-1 flex items-center gap-5 sm:gap-7 px-4 py-6 sm:p-6">
      <div data-testid="hero-rack-diagram" role="img" aria-label="Illustrative 24-unit server rack" className="shrink-0 w-[72px] sm:w-[88px] aspect-[80/220]">
        <RackDiagram className="w-full h-full text-[#0F1117]" />
      </div>
      <dl className="flex-1 min-w-0 space-y-5 sm:space-y-6">
        {RACK_METRICS.map(({ id, label, value, percentage }) => (
          <div key={id} data-testid={`hero-rack-metric-${id}`}>
            <dt data-testid={`hero-rack-label-${id}`} className="font-mono-label text-[10px] !tracking-normal text-[#71747B]">{label}</dt>
            <dd data-testid={`hero-rack-value-${id}`} className="font-display text-lg font-bold tracking-normal text-[#0F1117] mt-1 mb-2">{value}</dd>
            <div data-testid={`hero-rack-gauge-${id}`} aria-hidden="true"><GaugeBar value={percentage} max={100} /></div>
          </div>
        ))}
      </dl>
    </div>
    <div className="border-t hairline px-4 sm:px-5 py-3">
      <div className="flex items-center justify-between gap-3 mb-2">
        <span className="font-mono-label text-[10px] !tracking-normal text-[#5F6168]">Rack utilization</span>
        <span data-testid="hero-rack-utilization" className="font-mono-label text-[11px] !tracking-normal text-[#0F1117]">75%</span>
      </div>
      <div data-testid="hero-rack-utilization-gauge" role="meter" aria-label="Illustrative rack utilization" aria-valuenow={75} aria-valuemin={0} aria-valuemax={100}><GaugeBar value={75} max={100} /></div>
    </div>
  </section>
);